import React, { useState, useId, useEffect } from "react";

const Smallbutton = ({
  width = 236.5,
  height = 72.37,
  text = "SELECT",
  fontSize = 22,
  fill = "transparent",
  strokeWidth = 2,
  strokeColor = "url(#linear-gradient-small)",
  textColor = "#86189d",
  widthPercentage = "50%",
  country,
  className,
  rotate = false

}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [textWhite, setTextWhite] = useState(false);
  useEffect(() => {
    let timeout;
    if (isHovered) {
      // Wait 2 seconds after hover before changing text color
      timeout = setTimeout(() => {
        setTextWhite(true);
      }, 200);
    } else {
      // Reset immediately when not hovered
      setTextWhite(false);
      clearTimeout(timeout);
    }

    return () => clearTimeout(timeout);
  }, [isHovered]);
  const clipId = useId();

  const pathD = "M200.32.75H35.96C17.72.75,2.71,14.53.75,32.24h43.98l-12.77-12.77c-1.54-1.54-1.54-4.04,0-5.58,1.54-1.54,4.04-1.54,5.58,0l19.41,19.41c.79.79,1.17,1.84,1.15,2.88.02,1.04-.35,2.09-1.15,2.88l-19.41,19.41c-1.54,1.54-4.04,1.54-5.58,0-1.54-1.54-1.54-4.04,0-5.58l12.77-12.77H.75c1.96,17.71,16.97,31.49,35.21,31.49h164.36c19.57,0,35.43-15.86,35.43-35.43h0c0-19.57-15.86-35.43-35.43-35.43Z";

  return (
    <div
      style={{ display: "flex", cursor: "pointer" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <svg
        width={window.innerWidth < 500 ? widthPercentage : width}
        height={window.innerWidth < 500 ? "auto" : height}
        viewBox="0 0 236.5 72.37"
        xmlns="http://www.w3.org/2000/svg"
        style={{ overflow: "visible" }}
        className={className}
      >
        <defs>
          <linearGradient id="linear-gradient-small" x1="0" y1="36.18" x2="236.5" y2="36.18" gradientUnits="userSpaceOnUse">
            <stop offset="0" stopColor="#fa5c0d" />
            <stop offset="1" stopColor="#d81591" />
          </linearGradient>

          <clipPath id={clipId}>
            <rect
              x="0"
              y="0"
              width={isHovered ? "237" : "0"}
              height="73"
              style={{
                transition: "width 0.5s ease-in-out"
              }}
            />
          </clipPath>
        </defs>
        <defs>
          <linearGradient id="hoverGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#7e1790" />
            <stop offset="100%" stopColor="#d70a84" />
          </linearGradient>
        </defs>

        <g style={{
          transition: "transform 0.3s ease",
          transform: isHovered ? "scale(1.05)" : "scale(1)",
          transformOrigin: "center center",
          transformBox: "fill-box"
        }}>
          {/* Base path */}
          <path
            d={pathD}
            fill={fill}
            stroke={strokeColor}
            strokeWidth={textWhite ? "0" : strokeWidth}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{
              transition: 'stroke-width 0.3s ease, fill 0.3s ease'
            }}
          />

          {/* Red overlay that reveals from left */}
          <path
            d={pathD}
            fill="url(#hoverGradient)"

            clipPath={`url(#${clipId})`}
          />
        </g>

        {/* Text */}

        {!country ? (<text
          x="73.99"
          y="43.51"
          fill={textWhite ? "#FFFFFF" : textColor}
          fontFamily="Proxima Nova Bold, sans-serif"
          fontWeight="700"
          fontSize={fontSize}
          style={{ transition: "fill 0.3s ease", }}
        >
          {text}
        </text>) : (<text
          x={rotate ? "105" : "73.99"}
          y="43.51"
          fill={textWhite ? "#FFFFFF" : textColor}
          fontFamily="Proxima Nova Bold, sans-serif"
          fontWeight="700"
          fontSize={fontSize}
          style={{
            transition: "fill 0.3s ease",
            transform: rotate ? "rotate(180deg)" : "none",
            transformOrigin: "center",
          }}
        >
          {text}
        </text>)}
      </svg>
    </div>
  );
};

export default Smallbutton;